// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseQueryResult } from '@tanstack/react-query';
import { Credential } from '@daml.js/utility-credential-v0/lib/Utility/Credential/V0/Credential';
import { useLedgerApiClient } from '../../../contexts/LedgerApiContext';
import TemplateContract from '../../../utils/TemplateContract';
import { useQueryWithOptions } from '../../other/useQueryWithOptions';

const useCredentials: () => UseQueryResult<TemplateContract<Credential>[], string> = () => {
  const ledgerApi = useLedgerApiClient();

  return useQueryWithOptions({
    queryKey: ['queryCredentials'],
    queryFn: async (_, options) => {
      return ledgerApi.queryCredentials(options);
    },
  });
};

export default useCredentials;
